<template>
  <Head title="Avid Proposal" />
  
  <div class="container-fluid">
    <div class="row justify-content-center mx-4">
      <div class="col p-0">
        <public-proposal :proposal="proposal" :user="auth.user"></public-proposal>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
  proposal: Object,
  auth: Object
});
</script>

